<template>
  <div class="about">
	<section class="banner_area">
        <div class="banner_inner d-flex align-items-center">
            <div class="overlay bg-parallax" data-stellar-ratio="0.9" data-stellar-vertical-offset="0" data-background=""></div>
            <div class="container">
                <div class="banner_content text-center">
                    <h3 data-aos="fade-up" style="color: black">GitLeaf™️ is an IT Brand which goes align with modern technological advancements in order to satisfy their customer requirements. Its primary aim is to understand client’s needs thoroughly and fulfill them with our knowledge base and practice,ensuring to provide value to our Customers’ payments.</h3>
                </div>
            </div>
        </div>
    </section>
    <section class="section_gap big_features">
    <div class="container">
      <div class="row justify-content-center" > 
        <div class="col-lg-8 text-center">
          <div class="main_title">
            <h2 data-aos="fade-up">WHY CHOOSE GITLEAF AS YOUR MOBILE APP DEVELOPMENT PARTNER </h2>
          </div>
        </div>
      </div>
      <div class="row features_content" data-aos="fade-up">
        <div class="col-lg-4 offset-lg-1">
          <div class="big_f_left">
            <img class="img-fluid" src="img/f-img1.svg" alt="">
          </div>
        </div>
        <div class="col-lg-4 offset-lg-2">
          <div class="common_style">
            <h3>Agile Methodology</h3>
            <p>We follow the Agile methodology to facilitate rapid product releases with stability and high-quality code.</p>
            <a class="primary_btn" href="#"><span>Learn More</span></a>
          </div>
        </div>
        <div class="border-line"></div>
        <img class="shape1" src="img/shape1.png" alt=""/>   
        <img class="shape2" src="img/shape2.png" alt=""/>   
        <img class="shape3" src="img/shape1.png" alt=""/>   
      </div>

      <div class="row features_content bottom-features" data-aos="fade-up">
        <div class="col-lg-5">
          <div class="common_style">
            <h3>Bug-Free Deployment</h3>
            <p>Our Quality Maintain professionals use a combination of manual and automation testing to ensure that the app is released bug-free.</p>
            <a class="primary_btn" href="#"><span>Learn More</span></a>
          </div>
        </div>
        <div class="col-lg-5 offset-lg-2">
          <div class="big_f_left">
            <img class="img-fluid" src="img/f-img2.svg" alt="">
          </div>
        </div>
        <div class="border-line"></div>
        <img class="shape1" src="img/shape1.png" alt=""/>   
        <img class="shape2" src="img/shape2.png" alt=""/>   
        <img class="shape3" src="img/shape1.png" alt=""/>   
      </div>
    </div>
  </section>

  <Footer/>

  </div>
</template>

<script>
// @ is an alias to /src
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Footer
  }
};
</script>
